// import React, { useEffect, useState } from "react";
// import Header from "./Header";
// import "bootstrap/dist/css/bootstrap.min.css";
// import host from "../config";

// const BlockedData = () => {
//   const [blockedRooms, setBlockedRooms] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const roomsPerPage = 5; // Number of records per page

//   // Fetch blocked rooms from API
//   useEffect(() => {
//     fetch(`${host}/getBlockedRoomDetails`)
//       .then((response) => response.json())
//       .then((data) => setBlockedRooms(data.data))
//       .catch((error) => console.error("Error fetching blocked rooms:", error));
//   }, []);

//   // Pagination Logic
//   const indexOfLastRoom = currentPage * roomsPerPage;
//   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
//   const currentRooms = blockedRooms.slice(indexOfFirstRoom, indexOfLastRoom);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <>
//       <Header />
//       <div className="container mt-4">
//         <h2 className="text-center mb-4">Blocked Room Details</h2>
//         <div className="row">
//           <div className="col-12">
//             <table className="table table-striped table-hover">
//               <thead className="table-dark">
//                 <tr>
//                   <th>#</th>
//                   <th>Venue Name</th>
//                   <th>Location Name</th>
//                   <th>Blocked By</th>
//                   <th>Block Reason</th>
//                   <th>Blocked Date</th>
//                   <th>Attachment</th>
//                   <th>Status</th>
//                 </tr>
//               </thead>
//               <tbody style={{ textAlignLast: "center" }}>
//                 {currentRooms.length > 0 ? (
//                   currentRooms.map((room, index) => (
//                     <tr key={room.id}>
//                       <td>{indexOfFirstRoom + index + 1}</td>
//                       <td>{room.room_name}</td>
//                       <td>{room.location_name}</td>
//                       <td>{room.name}</td>
//                       <td>{room.blocked_reason || "N/A"}</td>
//                       <td>
//                         {new Date(room.calander_date).toLocaleDateString()}
//                       </td>
//                       <td>
//                         {room.attachment_url ? (
//                           <a
//                             href={room.attachment_url}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           "No Attachment"
//                         )}
//                       </td>

//                       <td>{room.is_blocked ? "Blocked" : "Available"}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="10" className="text-center">
//                       No Blocked Rooms Found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* Pagination */}
//             <nav>
//               <ul className="pagination justify-content-center">
//                 {Array.from(
//                   { length: Math.ceil(blockedRooms.length / roomsPerPage) },
//                   (_, index) => (
//                     <li
//                       key={index}
//                       className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => paginate(index + 1)}
//                       >
//                         {index + 1}
//                       </button>
//                     </li>
//                   )
//                 )}
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BlockedData;

// import React, { useEffect, useState } from "react";
// import Header from "./Header";
// import { FaEdit } from "react-icons/fa"; // Edit icon
// import "bootstrap/dist/css/bootstrap.min.css";

// const BlockedData = () => {
//   const [blockedRooms, setBlockedRooms] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const roomsPerPage = 5; // Number of records per page

//   // Fetch blocked rooms from API
//   useEffect(() => {
//     fetch("http://localhost:3000/getBlockedRoomDetails")
//       .then((response) => response.json())
//       .then((data) => setBlockedRooms(data.data))
//       .catch((error) => console.error("Error fetching blocked rooms:", error));
//   }, []);

//   // Unblock Room function
//   const handleUnblock = async (room) => {
//     if (!window.confirm("Are you sure you want to unblock this room?")) return;

//     const requestData = {
//       room_id: room.room_id,
//       location_id: room.location_id,
//       calendar_date: room.calander_date,
//     };

//     try {
//       const response = await fetch("http://localhost:3000/unblockRoom", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(requestData),
//       });

//       const result = await response.json();
//       if (result.success) {
//         alert("Room unblocked successfully!");
//         setBlockedRooms((prevRooms) =>
//           prevRooms.filter((r) => r.id !== room.id)
//         );
//       } else {
//         alert("Failed to unblock room.");
//       }
//     } catch (error) {
//       console.error("Error unblocking room:", error);
//     }
//   };

//   // Pagination Logic
//   const indexOfLastRoom = currentPage * roomsPerPage;
//   const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
//   const currentRooms = blockedRooms.slice(indexOfFirstRoom, indexOfLastRoom);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   return (
//     <>
//       <Header />
//       <div className="container mt-4">
//         <h2 className="text-center mb-4">Blocked Room Details</h2>
//         <div className="row">
//           <div className="col-12">
//             <table className="table table-striped table-hover">
//               <thead className="table-dark">
//                 <tr>
//                   <th>#</th>
//                   <th>Blocked Date</th>
//                   <th>Location Name</th>
//                   <th>Venue Name</th>
//                   <th>Block Reason</th>
//                   <th>Attachment</th>
//                   <th>Status</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentRooms.length > 0 ? (
//                   currentRooms.map((room, index) => (
//                     <tr key={room.id}>
//                       <td>{indexOfFirstRoom + index + 1}</td>
//                       <td>
//                         {new Date(room.calander_date).toLocaleDateString()}
//                       </td>
//                       <td>{room.location_name}</td>
//                       <td>{room.room_name}</td>
//                       <td>{room.block_reason || "N/A"}</td>
//                       <td>
//                         {room.attachment_url ? (
//                           <a
//                             href={room.attachment_url}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             View
//                           </a>
//                         ) : (
//                           "No Attachment"
//                         )}
//                       </td>
//                       <td>{room.is_blocked ? "Blocked" : "Available"}</td>
//                       <td>
//                         {room.is_blocked ? (
//                           <FaEdit
//                             onClick={() => handleUnblock(room)}
//                             className="text-primary cursor-pointer"
//                             title="Unblock Room"
//                             style={{ cursor: "pointer" }}
//                           />
//                         ) : (
//                           "-"
//                         )}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="8" className="text-center">
//                       No Blocked Rooms Found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* Pagination */}
//             <nav>
//               <ul className="pagination justify-content-center">
//                 {Array.from(
//                   { length: Math.ceil(blockedRooms.length / roomsPerPage) },
//                   (_, index) => (
//                     <li
//                       key={index}
//                       className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => paginate(index + 1)}
//                       >
//                         {index + 1}
//                       </button>
//                     </li>
//                   )
//                 )}
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BlockedData;

import React, { useEffect, useState } from "react";
import Header from "./Header";
import "bootstrap/dist/css/bootstrap.min.css";
import host from "../config";
import { FaEdit } from "react-icons/fa";

const BlockedData = () => {
  const [blockedRooms, setBlockedRooms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const roomsPerPage = 5;

  useEffect(() => {
    fetch(`${host}/getBlockedRoomDetails`)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data); // Debugging
        setBlockedRooms(data.data || []); // Ensure it's always an array
      })
      .catch((error) => {
        console.error("Error fetching blocked rooms:", error);
        setBlockedRooms([]); // Prevent undefined errors
      });
  }, []);

  // const handleUnblock = async (room) => {
  //   if (!window.confirm("Are you sure you want to unblock this room?")) return;

  //   // const requestData = {
  //   //   room_id: room.room_id,
  //   //   location_id: room.location_id,
  //   //   calendar_date: room.calander_date,
  //   // };

  //   const requestData = {
  //     room_id: room.room_id,
  //     location_id: room.location_id,
  //     calendar_date: new Date(room.calendar_date).toISOString().split("T")[0],
  //   };

  //   try {
  //     const response = await fetch("http://localhost:3000/unblockRooms", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(requestData),
  //     });

  //     const result = await response.json();
  //     if (result.success) {
  //       alert("Room unblocked successfully!");
  //       setBlockedRooms((prevRooms) =>
  //         prevRooms.filter((r) => r.id !== room.id)
  //       );
  //     } else {
  //       alert("Failed to unblock room.");
  //     }
  //   } catch (error) {
  //     console.error("Error unblocking room:", error);
  //   }
  // };

  const handleUnblock = async (room) => {
    if (!window.confirm("Are you sure you want to unblock this room?")) return;

    const requestData = {
      room_id: room.room_id,
      location_id: room.location_id,
      calendar_date: room.calander_date, // Use as is
    };

    try {
      const response = await fetch(`${host}/unblockRooms`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result.success) {
        alert("Room unblocked successfully!");
        setBlockedRooms((prevRooms) =>
          prevRooms.filter((r) => r.id !== room.id)
        );
      } else {
        alert("Failed to unblock room.");
      }
    } catch (error) {
      console.error("Error unblocking room:", error);
    }
  };

  const indexOfLastRoom = currentPage * roomsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
  const currentRooms = (blockedRooms || []).slice(
    indexOfFirstRoom,
    indexOfLastRoom
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h2 className="text-center mb-4">Blocked Room Details</h2>
        <div className="row">
          <div className="col-12">
            <table className="table table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Venue Name</th>
                  <th>Location Name</th>
                  <th>Blocked By</th>
                  <th>Block Reason</th>
                  <th>Blocked Date</th>
                  <th>Attachment</th>
                  <th>Status</th>
                  <th>Unblock</th>
                </tr>
              </thead>
              <tbody style={{ textAlignLast: "center" }}>
                {Array.isArray(blockedRooms) && blockedRooms.length > 0 ? (
                  currentRooms.map((room, index) => (
                    <tr key={room.id}>
                      <td>{indexOfFirstRoom + index + 1}</td>
                      <td>{room.room_name}</td>
                      <td>{room.location_name}</td>
                      <td>{room.name}</td>
                      <td>{room.blocked_reason || "N/A"}</td>
                      <td>
                        {new Date(room.calander_date).toLocaleDateString()}
                      </td>
                      <td>
                        {room.attachment_url ? (
                          <a
                            href={room.attachment_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "No Attachment"
                        )}
                      </td>
                      <td>{room.is_blocked}</td>
                      <td>
                        {room.is_blocked ? (
                          <FaEdit
                            onClick={() => handleUnblock(room)}
                            className="text-primary cursor-pointer"
                            title="Unblock Room"
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No Blocked Rooms Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            {blockedRooms.length > 0 && (
              <nav>
                <ul className="pagination justify-content-center">
                  {Array.from(
                    { length: Math.ceil(blockedRooms.length / roomsPerPage) },
                    (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockedData;
